import React from 'react'
import '../styles/components/BasicCard.css'

const BasicCard = ({ cardContent }) => {
  return <div className='rounded basic-card'>{cardContent}</div>
}

export default BasicCard
